<template>
  <div>
    <h1>Catchup on Hockey, init</h1>
    <section class="game-container">
      <ul class="games">
        <li v-for="game in games" v-bind:key="game.id">
          <span>{{ game.date | formatAsLocalString }} <a v-bind:href="specificVideoURLStart + game.vid_id + specificVideoURLEnd">{{ game.title }}</a></span>
        </li>
      </ul>
    </section>
    <div v-if="games.length > 0">
      <carousel>
        <div v-for="(key, vid) in videoLength" v-bind:key="vid.id">
          <video :id="`video${key - 1}`" controls autostart="false"></video>
          <h3>{{ games[key - 1].date | formatAsLocalString }}</h3>
          <h4>{{ games[key - 1].title }}</h4>
        </div>
      </carousel>
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";
import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel
  },
  name: "HelloWorld",
  props: {
    msg: String
  },
  data: function() {
    return {
      games: [],
      allVideoURL:
        "https://www.sportsnet.ca/wp-json/sportsnet/v1/video-page/?all=1",
      specificVideoURLStart:
        "https://secure.brightcove.com/services/mobile/streaming/index/master.m3u8?videoId=",
      specificVideoURLEnd: "&secure=true",
      videoLength: "",
      finishedLoading: false
    };
  },
  methods: {
    fetchData: async function(url) {
      let response = await fetch(url);
      let data = await response.json();
      return data;
    },
    init: async function() {
      const allVids = await this.fetchData(this.allVideoURL);
      const nhlHighlights = allVids[1].clips;
      const highlightsSortedByDate = nhlHighlights.sort((a, b) => b.ID - a.ID)
      this.videoLength = allVids[1].clips.length;
      highlightsSortedByDate.forEach(element => {
        let matches = {};
        matches.vid_id = element.bc_video_id;
        matches.date = element.post_date_gmt;
        matches.title = element.post_title;
        this.games.push(matches);
      });
    },
    loadVideo: function(numberOfvids) {
      for (let i = 0; i < numberOfvids; i++) {
        const video = document.getElementById(`video${i}`);
        const hls = new Hls();
        hls.loadSource(
          `https://secure.brightcove.com/services/mobile/streaming/index/master.m3u8?videoId=${this.games[i].vid_id}`
        );
        hls.attachMedia(video);
      }
      this.finishedLoading = true;
    }
  },
  filters: {
    formatAsLocalString: function(val) {
      return new Date(val).toLocaleString('en-GB', { dateStyle: "medium" });
    }
  },
  async mounted() {
    await this.init();
    await this.loadVideo(this.videoLength);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.games {
  text-align: left;
}
h3,h4 {
  font-size: 1em;
  margin: 0;
  padding: 0;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
}
h3 {
  margin-top: 10px
}
h4 {
  font-weight: 600;
}
video {
  max-width: 400px;
}
.game-container {
  display: flex;
  flex-direction: column;
  align-items: center; 
  ul {
    list-style: none;
    li {
      padding: 2px;
      span {
        font-weight: 600;
        a {
          font-weight: 300;
        }
      }
    }
  }
}
</style>
